import styled from 'styled-components';
import { animated } from 'react-spring';

export const FillSpaceContainer = styled(animated.div)`
    flex: 1;
    display: flex;
    align-items: stretch;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    min-height: 0px;
`;
